<script>
    import { NotificationModal } from "../../../../../Components/Common/index.svelte";

    import { getBillingItemCodeType } from "../../../../../Utils/utilFunctions.svelte";

    export let isModalOpen = false,
        selectedItemType = Number(0),
        closeModal = () => {},
        confirmAction = () => {},
        closeModalFunction = () => {};
</script>

<NotificationModal
    {isModalOpen}
    title="Warning"
    isReverseBtns
    cancelText="Confirm"
    submitText="Cancel"
    {closeModal}
    {confirmAction}
    {closeModalFunction}
>
    <p class="leading-6 whitespace-pre-line">
        Change items type to {getBillingItemCodeType(selectedItemType)}?
    </p>

    <p class="leading-6 whitespace-pre-line">
        Confirming will change the items type to {getBillingItemCodeType(
            selectedItemType,
        )} and remove all the existing billing data items.
    </p>
</NotificationModal>
